<template>
  <div>
    <div v-if="!userInfoShow" @click="pullUserInfo" style="cursor: pointer">
      <span v-if="userInfoMsg.iconType">
        <Icon style="margin-top:3px;cursor: pointer" size="14" color="#80848f"
              :title="iconType[userInfoMsg.iconType].title" :type="iconType[userInfoMsg.iconType].Icon">
        </Icon>
      </span>
      <span style="vertical-align: text-bottom">{{userInfoMsg.name}}</span>
    </div>

    <div v-if="userInfoShow">
      <Poptip v-model="userInfoShow" class="customPadding" placement="bottom-start" width='185' style="cursor:pointer;">
        <div @click="pullUserInfo">
      <span v-if="userInfoMsg.iconType">
        <Icon style="margin-top:3px;cursor: pointer" size="14" color="#80848f"
              :title="iconType[userInfoMsg.iconType].title" :type="iconType[userInfoMsg.iconType].Icon">
        </Icon>
      </span>
          <span style="vertical-align: text-bottom">{{userInfoMsg.name}}</span>
        </div>
        <div slot="content" v-if="userInfoShow">
          <div style="position:relative;overflow: hidden;display: flex;">
            <div style=" width: 30%;margin-top:8px;">
              <img :src="userCard.headImg" alt="" style="width:40px;border-radius:50%">
              <Icon v-if="" :color="userCard.statusColor" size="16"
                    :type="userCard.statusIcon" style="position: absolute;left:26px;bottom:2px;"></Icon>
            </div>
            <div style="width:70%;border-left:1px solid #e0e0e0;padding-left:5%;">
              <p
                style="line-height:25px;color:#333;width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                {{`${userCard.nickName}(${userCard.userName})`}}</p>
              <p
                style="line-height:25px;color:#333;width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                <span style="margin-right:10px;color:rgb(45, 140, 240)">{{userCard.deptName}}</span>
                <span style="margin-right:10px;color:rgb(45, 140, 240)">{{userCard.groupName}}</span>
              </p>
            </div>
          </div>
          <p style="line-height:25px;margin-left:5px;width:160px;color:#ccc">
            <img src="http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/header_name.png" alt=""
                 style="width:15px;display:inline-block;vertical-align: middle;color:#333;margin-right:2px;">
            姓名:
            <b style="color:#333">{{userCard.userName}}</b>
          </p>
          <p style="line-height:25px;margin-left:5px;width:160px;color:#ccc">
            <img src="http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/header_phone.png" alt=""
                 style="width:15px;display:inline-block;vertical-align: middle;color:#333;margin-right:2px;">
            手机:
            <b style="color:#333">{{userCard.phone}}</b>
          </p>
          <p style="line-height:25px;margin-left:5px;width:160px;color:#ccc">
            <img src="http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/header_wechat.png" alt=""
                 style="width:15px;display:inline-block;vertical-align: middle;color:#333;margin-right:2px;">
            微信:
            <b style="color:#333">{{userCard.weChatName}}</b>
          </p>
          <div @click="enlargeImg(userCard.weChatImg)" style="margin-bottom: 10px">
            <img :src="userCard.weChatImg" alt="" style="width:100px;display:block;margin:auto;">
          </div>
          <div style="text-align: center">
            <Button type="primary" size="small" @click="fToUrged">催一次</Button>
          </div>
        </div>
      </Poptip>
    </div>
  </div>
</template>

<script>
  import {Poptip} from 'iview'

  export default {
    name: "business-card",
    components: {Poptip},
    props: {
      userInfo: {
        type: Object,
      }
    },
    data() {
      return {
        userInfoShow: false,
        userCard: {
          headImg: '',
          nickName: '',
          userName: '',
          deptName: '',
          groupName: '',
          phone: '',
          weChatName: '',
          weChatImg: '',
          statusFlag: 0,
          statusIcon: '',
          statusColor: '',
          statusIconType: {
            '1': 'checkmark-circled',
            '0': 'close-circled',
            '8': 'information-circled',
            '9': 'minus-circled',
          },
          statusColors: {
            '1': '#19be6b',
            '0': '#bbbec4',
            '8': '#ed3f14',
            '9': '#ff9900',
          }
        },
        iconType: {
          "1": {
            "title": "系统自动分配",
            "Icon": "shuffle"
          },
          "2": {
            "title": "手动分配",
            "Icon": "network"
          },
          "3": {
            "title": "录入时指定",
            "Icon": "compose"
          },
          "4": {
            "title": "主管转移",
            "Icon": "steam"
          },
          "5": {
            "title": "excsl导入",
            "Icon": "ios-cloud-upload"
          }
        },
      }
    },
    computed: {
      userInfoMsg() {
        return this.userInfo
      }
    },
    methods: {
      //获取用户信息
      pullUserInfo() {
        this.$http.get('/staff/card', {
          params: {
            staffId: this.userInfoMsg.staffId
          }
        }).then((data) => {
          if (data.code === 100000) {
            if (data.data.headImg && data.data.headImg != 'false') {
              this.userCard.headImg = data.data.headImg
            } else {
              this.userCard.headImg = 'http://img.yunduanbian.cn:9000/crm-client/beidou/hash/head_img_default.jpg'
            }
            if (data.data.weChatImg && data.data.weChatImg != 'false') {
              this.userCard.weChatImg = data.data.weChatImg
            } else {
              this.userCard.weChatImg = 'http://img.yunduanbian.cn:9000/crm-client/beidou/hash/default_qr_code.png'
            }
            this.userCard.nickName = data.data.nickName
            this.userCard.weChatName = data.data.weChatName
            this.userCard.userName = data.data.userName
            this.userCard.deptName = data.data.deptName
            this.userCard.groupName = data.data.groupName
            this.userCard.phone = data.data.phone
            this.userCard.statusFlag = data.data.statusFlag
            this.userCard.statusIcon = this.userCard.statusIconType[this.userCard.statusFlag]
            this.userCard.statusColor = this.userCard.statusColors[this.userCard.statusFlag]
            this.userInfoShow = true
          } else {
            this.$Message.error(data.msg)
          }
        })
      },

      //放大图片
      enlargeImg(imgSrc) {
        document.getElementById('modalImgUrl').src = imgSrc
        document.getElementById('modalImg').style.display = 'block'
        document.getElementById('modalImg').onclick = () => {
          document.getElementById('modalImgUrl').src = ''
          document.getElementById('modalImg').style.display = 'none'
        }
      },

      //催一次
      fToUrged() {
        this.$http.get('/news/push_info_news_in_app', {
          params: {
            kzId: this.userInfo.kzId,
            toStaffId: this.userInfo.staffId,
            msg: '催一次'
          }
        }).then((data) => {
          if (data.code === 100000) {
            this.$Message.success(data.msg)
          } else {
            this.$Message.error(data.msg)
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-card.vue